export default __webpack_public_path__ + "static/media/bidding-strategy-unselected.31421148.png";